/* eslint-disable @typescript-eslint/member-ordering */
import {computed, makeObservable, observable} from "mobx";
import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {AbstractModel} from "./abstract-model";

export interface ProcessSourceProps {
    objectId?: number;
    guid?: string;
    mainProcessId?: number;
    processSourceNr?: string;
    processSourceName?: string;
    processSource?: string;
}

/**
 * Auftragnehmer
 */
@JsonObject()
export class ProcessSource extends AbstractModel {

    static readonly comparableAttributes: string[] = [
        "hpa", "pq_nr_gk", "pq_name", "prozessquelle"
    ];
    // workaround, because feature template doesn't seem to work for table features
    static readonly prototypeAttributes: string[] = [
        "OBJECTID", "hpa", "pq_nr_gk", "pq_name", "prozessquelle"
    ];
    // field mappings
    static readonly databaseFieldNames: Map<string, string> = new Map<string, string>([
        ["objectId", "OBJECTID"],
        ["mainProcessId", "hpa"],
        ["processSourceNr", "pq_nr_gk"],     // for csv export to work
        ["processSourceName", "pq_name"],
        ["processSource", "prozessquelle"],
    ]);

    class = "ProcessSource";
    typeLabel = "Prozessquelle";

    static sortByName(a: ProcessSource, b: ProcessSource) {
        const nameA = a.processSourceName; // ignore upper and lowercase
        const nameB = b.processSourceName; // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        // names must be equal
        return 0;
    }

    /**
     * Eindeutiger Identifikator
     * Im Datenmodell wurde "prozessquelle" verwendet, der zusammengesetzte Name anstatt nur die Nummer!
     */
    @JsonProperty({name: "prozessquelle"})
        guid: string;

    /**
     * Hauptprozess
     */
    @JsonProperty({name: "hpa"})
        mainProcessId: number;

    /**
     * Prozessquelle Nr.
     */
    @JsonProperty({name: "pq_nr_gk"})
        processSourceNr: string;

    /**
     * Prozessquelle Name
     */
    @JsonProperty({name: "pq_name"})
        processSourceName: string;

    /**
     * Prozessquelle
     */
    @JsonProperty({name: "prozessquelle"})
        processSource: string;

    constructor(props?: ProcessSourceProps) {
        super();
        if (props) {
            Object.assign(this, props);
        }
        // make observable after setting properties to avoid 'strict' messages
        makeObservable(this, {
            objectId: observable, // do observe to reload when object is saved
            guid: observable,

            mainProcessId: observable,
            processSourceNr: observable,
            processSourceName: observable,
            processSource: observable,

            isAlterable: computed,
            isNewRecord: computed
        });
    }

    get displayLabel(): string {
        return `${this.processSourceName} (${this.processSourceNr})`;
    }

    get comparableAttributes(): string[] {
        return ProcessSource.comparableAttributes;
    }

    /**
     * If process source properties are allowed to change.
     */
    get isAlterable(): boolean {
        return true;
    }

}
